import React, { useRef, useState } from 'react';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import styles from './ZoomTypeItem.module.scss';
import FloatingTooltip from '../../../../components/FloatingTooltip/FloatingTooltip';

const ZoomTypeItem = ({ type, tooltip, active, onClick }) => {
  const [hover, setHover] = useState(false);
  const containerRef = useRef();
  const { t } = useTranslation();

  return (
    <div
      ref={containerRef}
      className={cx(styles.container, { [styles.active]: active })}
      onMouseOver={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={() => onClick(type)}
    >
      <div className={cx(styles.image, styles[type])} />
      {tooltip && hover && <FloatingTooltip containerRef={containerRef} label={t(tooltip)} offset={30} />}
    </div>
  );
};

export default ZoomTypeItem;
